import { render, staticRenderFns } from "./BugReportInfoModal.vue?vue&type=template&id=26c320c8&scoped=true&"
import script from "./BugReportInfoModal.vue?vue&type=script&lang=ts&"
export * from "./BugReportInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./BugReportInfoModal.vue?vue&type=style&index=0&id=26c320c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c320c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VTooltip})
